var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState } from 'react';
import { motion } from "framer-motion";
export default function StripHoursOfOperation(props) {
    var fields = props.fields, children = props.children, isFlyoverSite = props.isFlyoverSite;
    var TitleTag = (fields.titleTag || 'h1');
    var _a = useState(null), hourItems = _a[0], setHourItems = _a[1];
    useEffect(function () {
        var newHourItems = [];
        fields.hoursOfOperation && fields.hoursOfOperation.forEach(function (item) {
            var lastItem = newHourItems.length > 0 ? newHourItems[newHourItems.length - 1] : null;
            if (!lastItem || !lastItem.isRegularDay || !item.isRegularDay || lastItem.openingHours != item.openingHours || lastItem.closingHours != item.closingHours) {
                newHourItems.push(item);
            }
            else {
                lastItem.lastGroupItemTitle = (item.shortDayTitle || item.dayTitle);
            }
        });
        setHourItems(newHourItems);
    }, [fields]);
    var getSecondColumnWidth = function (firstColWidth) {
        switch (firstColWidth) {
            case '2':
                return "10";
            case '3':
                return "9";
            case '4':
                return "8";
            case '5':
                return "7";
            default:
                return "6";
        }
    };
    return (React.createElement(motion.div, __assign({ initial: { opacity: 0 }, whileInView: { opacity: 1 }, viewport: { once: true, margin: "-20%" }, className: "strip spa-hours-of-operation position-relative component mb-4  "
            + ((fields.topPadding) ? (" top-padding-" + fields.topPadding) : "")
            + ((fields.bottomPadding) ? (" bottom-padding-" + fields.bottomPadding) : "")
            + ((fields.topMargin) ? (" top-margin-" + fields.topMargin) : "")
            + ((fields.bottomMargin) ? (" bottom-margin-" + fields.bottomMargin) : "")
            + (" bg-" + (fields.backgroundColour ? fields.backgroundColour : ""))
            + (" text-color-" + (fields.textColour ? fields.textColour : "")) }, (fields.jumplinkLabel ? { id: fields.jumplinkLabel.replace(/ /g, '') } : {})),
        React.createElement("div", { className: "container-fluid" },
            React.createElement("div", { className: "row" }, (fields.displayTitle || fields.content) &&
                React.createElement("div", { className: "col-12 intro-text-row", itemScope: true, itemType: "https://schema.org/Thing" },
                    fields.displayTitle &&
                        React.createElement(TitleTag, { className: "title " + fields.titleStyle, itemProp: "name", dangerouslySetInnerHTML: { __html: fields.displayTitle } }) || null,
                    fields.content &&
                        React.createElement("div", { className: "strip-content", dangerouslySetInnerHTML: { __html: fields.content }, itemProp: "description" }))),
            hourItems && hourItems.map(function (item) {
                return React.createElement("div", { className: "row mb-2" },
                    React.createElement("div", { className: "col-sm-4 col-4 day-title col-md-" + fields.firstColumnWidth }, !!item.lastGroupItemTitle ? React.createElement(React.Fragment, null, (item.shortDayTitle || item.dayTitle) + " - " + (item.lastGroupItemTitle)) : React.createElement(React.Fragment, null, item.dayTitle)),
                    React.createElement("div", { className: "operational-hours d-flex flex-wrap col-sm-8 col-8 col-md-" + getSecondColumnWidth(fields.firstColumnWidth) }, (item.openingHours && item.closingHours && React.createElement(React.Fragment, null,
                        React.createElement("div", null,
                            React.createElement("span", { className: "hours mb-2" }, item.openingHours)),
                        " ",
                        React.createElement("span", { className: "mx-1 mx-md-2 mb-2" }, "TO"),
                        " ",
                        React.createElement("div", null,
                            React.createElement("span", { className: "hours mb-2" }, item.closingHours)))) || React.createElement("div", null,
                        React.createElement("span", { className: "hours" }, "Closed"))));
            }))));
}
